/**
 * Loads modules required for the main content matrix
 */

import anchorLinks from '@modules/anchorLinks';
import { loadModule, loadModulesWhenInView } from '@helpers/loadModule';
import { Observer } from 'tailwindcss-intersect';

export default function init(): void {
  anchorLinks();
  Observer.start();
  // Load optional modules when in view
  loadModulesWhenInView([
    {
      selector: '.js-accordion-item',
      importer: () => import('@modules/accordion'),
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/formieCsrf') as Promise<Module<HTMLFormElement>>,
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/gtmFormSubmission') as Promise<Module<HTMLFormElement>>,
    },
    {
      selector: '.js-swiper',
      importer: () => import('@modules/swiper') as Promise<Module<HTMLDivElement>>,
    },
    {
      selector: '.js-map',
      importer: () => import('@modules/google-maps') as Promise<Module<HTMLDivElement>>,
      distance: 250,
    },
    {
      selector: '.js-social-share-button',
      importer: () => import('@modules/socialShare') as Promise<Module<HTMLDivElement>>,
    },
    {
      selector: '.js-video-modal',
      importer: () => import('@modules/videoModal') as Promise<Module<HTMLDivElement>>,
    },
    {
      selector: '.js-wistia-embed',
      importer: () => import('@modules/wistia') as Promise<Module<HTMLDivElement>>,
    },
    {
      selector: '.js-video-container',
      importer: () => import('@modules/video') as Promise<Module<HTMLDivElement>>,
    },
  ]);

  // Admin bar - load if exists but not necessarily in view
  loadModule(
    '.js-admin-bar',
    () => import('@modules/adminBar') as Promise<Module<HTMLElement>>,
    true,
  );
}
